export * from './asset-image.module';
